import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { BREAKPOINTS, CONTAINER_X_PADDING } from '../../../../styles/constants'

/** Space reserved for NativeSlider absolute arrows (matches notino.cz shop categories track margin) */
const SLIDER_ARROW_GUTTER_PX = 48

export const TopLevelCategoriesSliderWrapper = styled.nav`
	margin-top: 16px;
	/* Full-bleed within the page container (same pattern as ElementsSlider) */
	margin-left: -${CONTAINER_X_PADDING}px;
	margin-right: -${CONTAINER_X_PADDING}px;

	@media (min-width: ${BREAKPOINTS.md}) {
		/*
		* NativeSlider DOM: SliderWrapper > [prev arrow wrap, scroll track, next arrow wrap].
		* Production styleguide insets the track (~48px) so chevronInCircle arrows don't cover slides.
		* Our installed NativeSlider does not apply that margin yet, so we mirror it here.
		*/
		& > div > div:nth-child(2) {
			margin-left: ${SLIDER_ARROW_GUTTER_PX}px;
			margin-right: ${SLIDER_ARROW_GUTTER_PX}px;
		}
	}

	@media (min-width: ${BREAKPOINTS.lg}) {
		margin-top: 40px;
	}
`

/** App-level slide cell (same role as shop's shopCategoriesContainer) — NativeSlider sets equal width */
export const TopLevelCategorySlide = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const TopLevelCategoryTitle = styled.div`
	text-align: center;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	color: ${theme.color.text.primary} !important; // fix color for iphone

	/* line clamp */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`

export const TopLevelCategoryLink = styled.a`
	text-decoration: none;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 80px;
	margin: 0 auto;
`

export const TopLevelCategoryImgWrapper = styled.div`
	width: 80px;
	height: 80px;
	border-radius: 999px;
	position: relative;
	overflow: hidden;
	margin-bottom: 10px;
	flex-shrink: 0;
`

export const TopLevelCategoryImg = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`
